import { motion } from "framer-motion";

export const FounderSection = () => {
  return (
    <section 
      id="founder"
      data-testid="founder-section"
      className="py-20 md:py-28 px-6 md:px-12 relative"
    >
      <div className="max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl p-8 md:p-12 relative overflow-hidden"
          style={{
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03), 0 4px 16px rgba(0, 0, 0, 0.04)'
          }}
        >
          {/* Letter surface depth - subtle top highlight */}
          <div 
            className="absolute inset-0 pointer-events-none rounded-3xl"
            style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.7) 0%, transparent 40%)' }}
          />
          {/* Letter surface depth - subtle bottom edge */}
          <div 
            className="absolute inset-0 pointer-events-none rounded-3xl"
            style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.015) 0%, transparent 25%)' }}
          />
          
          <p className="text-sm font-medium uppercase tracking-widest text-[#0CBCBF] mb-6 relative z-10">
            A note from the maker
          </p>
          
          <h2 className="font-handwritten text-3xl md:text-4xl text-[#F58227] mb-6 relative z-10">
            I built this because...
          </h2>
          
          <div className="space-y-4 text-[#52525B] text-[17px] leading-relaxed relative z-10">
            <p>
              I kept picking up my phone to do something important, and three minutes later 
              I'd be watching videos with no memory of why I unlocked it.
            </p>
            <p>
              Most productivity apps made me feel worse. They demanded consistency I didn't have. 
              My forgetfulness felt punished. The guilt piled on.
            </p>
            <p>
              I wanted something different. A tool that doesn't judge the 47 open tabs. 
              That simply asks: <em>"What were you trying to do?"</em>
            </p>
            <p className="text-[#27272A] font-medium">
              This is that tool. No shame. No hustle. Just a gentle way back.
            </p>
          </div>
          
          <div className="mt-8 pt-6 border-t border-stone-100/60 relative z-10">
            <p className="text-sm text-[#A1A1AA]">
              — The Maker
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
